<section class="welcome-section">
  <ose-endless-line class="black-background" type="black"></ose-endless-line>
  <div class="netfone-container">
    <span class="d-inline-block"></span>
    <div class="title-wrapper">
      <h1 class="title-bar" [ngStyle]="{ 'font-size': generateNameFontSize() }">{{ user.nev }}</h1>
      <h1 class="title-bar secondary">Értékesítési Partner</h1>
    </div>
    <h3 class="motto-1">{{ user.motto }}</h3>
    <h3 class="motto-2">A Netfone mobilszolgáltató képviselője vagyok</h3>
    <div class="image-wrapper">
      <img [src]="profileImgSrc" [alt]="user.nev" (error)="onFailLoadImage()" class="title-image" />
    </div>
  </div>
</section>

<section class="welcome-section-mobile">
  <div class="image-wrapper">
    <img [src]="profileImgSrc" [alt]="user.nev" (error)="onFailLoadImage()" class="title-image" />
  </div>
  <div class="netfone-container black-background-container" id="black-background-container">
    <ose-endless-line class="black-background" type="black"></ose-endless-line>
    <h3 class="title-bar" [ngStyle]="{ 'font-size': generateNameFontSize() }">{{ user.nev }}</h3>
    <h3 class="title-bar secondary">Értékesítési partner</h3>
  </div>
  <div class="netfone-container white-background-container" [ngStyle]="{ top: getOrangeElementTopOffset() }">
    <ose-endless-line class="white-background" type="white"></ose-endless-line>
    <h3 class="motto-1">A Netfone mobilszolgáltató képviselője vagyok.</h3>
  </div>
</section>

<section class="contact-detail-section">
  <div class="netfone-container">
    <h3 class="motto">
      {{ user.motto }}
    </h3>
    <h3 class="contact-details title highlight0">{{ getUserCity(user.telepules) }} és környéke</h3>
    <h3 class="contact-details">
      Mindig jókor hívsz: <a class="highlight" [href]="'tel:' + user.telefonszam">{{ user.telefonszam }}</a>
      <br />E-mail cím:
      <a class="highlight" [href]="'mailto:' + user.email">{{ user.email }}</a>
    </h3>
  </div>
</section>

<div id="scroll-here"></div>

<section class="packages-section">
  <div class="light-orange-design-circle"></div>
  <div class="dark-orange-design-circle"></div>
  <div class="section-title-wrapper">
    <div class="netfone-container">
      <h1 class="title">Nézd meg akciós csomagajánlatainkat 10 hónapos hűséggel.</h1>
    </div>
  </div>
  <div class="netfone-container">
    <div class="flex-row justify-content-start">
      <h3 class="subtitle">Legnépszerűbb csomagjaink</h3>
    </div>
    <div class="package-wrapper">
      <ose-large-mobile-package
        *ngFor="let packageItem of packages"
        [packageDetails]="packageItem"
        (buttonClicked)="order($event)"
        [displayAsPillOnMobile]="true"
      ></ose-large-mobile-package>
    </div>
  </div>
</section>

<ose-all-packages [data]="allServicesData" [backgroundColor]="'black'" *ngIf="allServicesData"></ose-all-packages>

<ose-grey-ribbon-with-share-button
  [customDescription]="getCustomRibbonDescription()"
  [customClasses]="'mb-m-40'"
></ose-grey-ribbon-with-share-button>

<section class="advantage-section">
  <div class="netfone-container">
    <div class="advantage reverse">
      <div class="image-container"><img class="advantage-image" [src]="profileImgSrc" [alt]="user.nev" /></div>
      <div class="advantage-body">
        <ose-endless-line type="light-gray" class="advantage-background"></ose-endless-line>
        <h3 class="advantage-title">Dolgozz velem!</h3>
        <h3 class="advantage-subtitle">
          Legyél Te is a Netfone partnere, <br />
          köss kedvező mobilelőfizetéseket!
        </h3>
        <p class="advantage-description">
          Észrevetted, hogy a környezetedben mindenki mobilozik? Segítsd őket kedvező Netfone előfizetéshez és legyen
          rendszeres üzletkötői jutalékod! Az üzleti modellünk olyan megoldást biztosít számodra, amellyel kedvező
          feltételekkel tudsz a Netfone értékesítési partnerévé válni és részese lenni ennek az új mobilszolgáltatónak.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="contact-section">
  <div class="netfone-container">
    <h1 class="title">Itt tudsz jelentkezni, ha Te is üzletkötőnk szeretnél lenni!</h1>
    <div class="contact-us-data-wrapper">
      <div [formGroup]="editForm" class="contact-us-form">
        <div class="form-wrapper justify-content-center">
          <div class="form-row-wrapper">
            <div class="col">
              <div class="form-group left-item">
                <label
                  [ngClass]="{
                    'ntfc-has-error': f.name.invalid && (f.name.dirty || f.name.touched),
                    'ntfc-has-success': f.name.valid && (f.name.dirty || f.name.touched)
                  }"
                  class="ntfc-form-label"
                  for="name"
                  >Név</label
                >
                <input
                  [ngClass]="{
                    'ntfc-form-control-danger': f.name.invalid && (f.name.dirty || f.name.touched),
                    'ntfc-form-control-success': f.name.valid && (f.name.dirty || f.name.touched)
                  }"
                  autocomplete="given-name"
                  aria-describedby="name"
                  class="ntfc-input-100"
                  formControlName="name"
                  id="name"
                  placeholder="*Kötelező"
                  required
                  type="text"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group right-item">
                <label
                  [ngClass]="{
                    'ntfc-has-error': f.city.invalid && (f.city.dirty || f.city.touched),
                    'ntfc-has-success': f.city.valid && (f.city.dirty || f.city.touched)
                  }"
                  class="ntfc-form-label"
                  for="city"
                  >Város / település</label
                >
                <input
                  [ngClass]="{
                    'ntfc-form-control-danger': f.city.invalid && (f.city.dirty || f.city.touched),
                    'ntfc-form-control-success': f.city.valid && (f.city.dirty || f.city.touched)
                  }"
                  autocomplete="family-name"
                  aria-describedby="city"
                  class="ntfc-input-100"
                  formControlName="city"
                  id="city"
                  placeholder="*Kötelező"
                  required
                  type="text"
                />
              </div>
            </div>
          </div>
          <div class="form-row-wrapper">
            <div class="col">
              <div class="form-group left-item">
                <label
                  [ngClass]="{
                    'ntfc-has-error': f.email.invalid && (f.email.dirty || f.email.touched),
                    'ntfc-has-success': f.email.valid && (f.email.dirty || f.email.touched)
                  }"
                  class="ntfc-form-label"
                  for="email"
                  >E-mail</label
                >
                <input
                  [ngClass]="{
                    'ntfc-form-control-danger': f.email.invalid && (f.email.dirty || f.email.touched),
                    'ntfc-form-control-success': f.email.valid && (f.email.dirty || f.email.touched)
                  }"
                  autocomplete="email"
                  aria-describedby="email"
                  class="ntfc-input-100"
                  formControlName="email"
                  id="email"
                  placeholder="*Kötelező"
                  required
                  type="email"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group right-item">
                <label
                  [ngClass]="{
                    'ntfc-has-error': f.phoneNumber.invalid && (f.phoneNumber.dirty || f.phoneNumber.touched),
                    'ntfc-has-success': f.phoneNumber.valid && (f.phoneNumber.dirty || f.phoneNumber.touched)
                  }"
                  class="ntfc-form-label"
                  for="phoneNumber"
                  >Telefonszám</label
                >
                <input
                  [maxLength]="15"
                  [ngClass]="{
                    'ntfc-form-control-danger': f.phoneNumber.invalid && (f.phoneNumber.dirty || f.phoneNumber.touched),
                    'ntfc-form-control-success': f.phoneNumber.valid && (f.phoneNumber.dirty || f.phoneNumber.touched)
                  }"
                  aria-describedby="phoneNumber"
                  class="ntfc-input-100"
                  formControlName="phoneNumber"
                  id="phoneNumber"
                  mask="+00-00-0000000"
                  ngbTooltip="+36-70-1234567"
                  placeholder="*Kötelező"
                  placement="bottom"
                  required
                  type="tel"
                />
                <span class="phone-tooltip">pl: +36 70 1234567 </span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label
              [ngClass]="{
                'ntfc-has-error': f.comment.invalid && (f.comment.dirty || f.comment.touched),
                'ntfc-has-success': f.comment.valid && (f.comment.dirty || f.comment.touched)
              }"
              class="ntfc-form-label"
              for="comment"
              >Megjegyzés</label
            >
            <textarea
              [ngClass]="{
                'ntfc-textarea-danger': f.comment.invalid && (f.comment.dirty || f.comment.touched),
                'ntfc-textarea-success': f.comment.valid && (f.comment.dirty || f.comment.touched)
              }"
              aria-describedby="comment"
              class="ntfc-textarea-input"
              formControlName="comment"
              id="comment"
              placeholder="Megjegyzés"
              required
              rows="4"
              type="text"
            ></textarea>
          </div>
        </div>
        <ose-recaptcha [captchaFormControl]="f.captcha"></ose-recaptcha>

        <button
          class="netfone-button primary contact-us-form-send mb-4"
          (click)="onSend()"
          [disabled]="editForm.invalid"
        >
          <img *ngIf="isSent()" class="sent-marker" src="../../../../assets/images/check.svg" alt="" />{{
            formSubmitText
          }}
        </button>
      </div>
      <div class="instructions">
        <ol>
          <li>
            Add meg az adataidat, <br />
            ha üzletkötő szeretnél lenni!
          </li>
          <li>Üzeneted eljut hozzám.</li>
          <li>
            A legrövidebb időn belül felveszem <br />
            a kapcsolatot Veled.
          </li>
          <li>
            Adataidat bizalmasan, a hatályos <br />
            jogszabályoknak megfelelően kezeljük.
          </li>
        </ol>
      </div>
    </div>
  </div>
</section>
